import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const consultarAfiliadoFarmaCardUrl = "/api/v1/websalud/primeraars/farmacard/infoafiliado";
const consultarNumeroPlasticoUrl =
  "api/v1/websalud/primeraars/asegurado/plastico";

const consultarAfiliadoFarmaCard = (request) => {
  const params = {
    Parametro: request.requestData.Parametro,
    Pss: request.requestData.Pss,
  };

  return InterceptToken(
    BaseApi.get,
    consultarAfiliadoFarmaCardUrl,
    params,
    null
  ).then((response) => response.data);
};

//eliminar
const consultarNumeroPlastico = (request) =>
  InterceptToken(BaseApi.get, consultarNumeroPlasticoUrl, request).then(
    (response) => response.data
  );

const exportedObject = {
  consultarAfiliadoFarmaCard,
  consultarNumeroPlastico,
};

export default exportedObject;

